if(typeof lazySizes === 'undefined'){
	/*! lazysizes - v4.1.8 */
  !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
  /*! ls.rias.min.ks - v4.1.8 */
  !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
        paginationType: 'default',
        // Placeholder
        showPlaceholderProductList: true,
        placeholderProductPerRow: 6,
        activeLoadPreviousPage: true
        // paginationTypeAdvanced: false,
    },
    template: {
        btnLoadPreviousPageTemplate: '<div id="bc-sf-filter-btn-load-previous-page"><a href="javascript:void(0)" aria-label="{{label.loadPreviousPage}}" class="js-bc-sf-filter-btn-load-previous-page">Load {{count}} Previous Products</a></div>',
    }
};

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices

  // Convert images to array
  images = data.images_info;
  console.log("images_info",data.images_info);
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // console.log('data',data.title);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  itemHtml = itemHtml.replace(/{{productID}}/g, data.id)
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Permenant TAG Label
  itemHtml = itemHtml.replace(/{{itemPermenantLable}}/g, buildPermenantTagLabels(data));
  // Add Variant html
  itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildVariants(data));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  //Add multiple Images
  itemHtml = itemHtml.replace(/{{itemMultiImages}}/g, buildMultipleImages(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, '');
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

  // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Permenant TAG Label
  itemHtml = itemHtml.replace(/{{itemPermenantLable}}/g, buildPermenantTagLabels(data));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

  //Add multiple Images
  itemHtml = itemHtml.replace(/{{itemMultiImages}}/g, buildMultipleImages(data));

  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass() {
  var gridWidthClass = '';
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5';
      break;
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildVariants(data) {
var html = '';
 html += '<div class="prod-content-swatch w-left">';
   // html += '<div class="product-sw-title h6">AVAILABLE SIZE</div>';
  html += '<div class="product-sw-title h6">{{optionHeadingTitle}}</div>';
     html +=  '<div class="product-i-swatch">';
  var hasOption = false;
  var option_denominations = '';
  for (var i = 0; i < data['variants'].length; i++) {
    
    // if (data['variants'][i].available) {
      var variantList = data['variants'][i];
      
      var valueDiffOption = variantList.option_size;
      if(valueDiffOption === undefined && variantList.option_scent !== undefined){
        valueDiffOption = variantList.option_scent;
      }
      // (1/2) Start Boost 205804
      if (variantList.original_merged_options) {
        var original_option_size = variantList.original_merged_options.find(e => e.indexOf('size:') === 0);
        if (typeof original_option_size !== 'undefined') {
          valueDiffOption = original_option_size.split('size:')[1];
        }
      }
      if (typeof variantList.option_denominations !== 'undefined') {
        if (data['variants'][i].available) {
          option_denominations += '<a href="'+ data.json.url+'?variant='+ variantList.id +'" class="col-size-toggle " data-id="'+variantList.id+'" ontouchmove="return true">'+ variantList.option_denominations +'</a>'
        }else{
          option_denominations += '<a href="'+ data.json.url+'?variant='+ variantList.id +'" class="col-size-toggle col-size-soldout" data-id="'+variantList.id+'" ontouchmove="return true">'+ variantList.option_denominations +'</a>'
        }
      }
      // (1/2)End Boost 205804
      // html += '<a href="'+ data.json.url+'?variant='+ variantList.id +'">'+ variantList.option_size +'</a>';
      if (typeof valueDiffOption !== 'undefined') {
          hasOption = true;
         if (data['variants'][i].available) {
          html += '<a href="'+ data.json.url+'?variant='+ variantList.id +'" class="col-size-toggle" data-id="'+variantList.id+'" ontouchmove="return true">'+ valueDiffOption +'</a>';
         }
        else{
          html += '<a href="'+ data.json.url+'?variant='+ variantList.id +'" class="col-size-toggle col-size-soldout" data-id="'+variantList.id+'" ontouchmove="return true">'+ valueDiffOption +'</a>';
        }
      }
    // }
  }
  // (2/2) Start Boost 205804
  if (!hasOption && option_denominations.length > 15) {
    html += option_denominations;
      html = html.replace(/{{optionHeadingTitle}}/g, 'SELECT DENOMINATIONS');
  }
  // (2/2) End Boost 205804
  html = html.replace(/{{optionHeadingTitle}}/g, 'AVAILABLE SIZES');
  html += '</div>';  
  html += '</div>';
  html += '<div class="col-size-popup">';
  html += '<span class="col-close"><svg xmlns="http://www.w3.org/2000/svg" width="13.414" height="13.414" viewBox="0 0 13.414 13.414"><g id="Group_1155" data-name="Group 1155" transform="translate(-393.293 -148.293)"><path id="Line_111" data-name="Line 111" d="M.707,12.707-.707,11.293l12-12L12.707.707Z" transform="translate(394 149)"/><path id="Line_112" data-name="Line 112" d="M11.293,12.707l-12-12L.707-.707l12,12Z" transform="translate(394 149)"/></g></svg></span>';    
  html += '<div class="col-sizes">';
  html += '<a class="size-toggle"  href="javascript:void(0)" data-id="">42</a>';
  html += '</div>';
  html += '<a href="javascript:void(0);" class="btn btn-full btn-col-add">Add To Cart</a>';
  html += '</div>';
  return html;
}

function buildImages(data) {
  var html = '';
  // Build Main Image
  var thumbUrl = images.length > 0 ? images[0]['src'] : bcSfFilterConfig.general.no_image_url;
  html += '<img class="bc-sf-filter-product-item-main-image lazyload" ontouchmove ="return true"' +
    'src="' + bcsffilter.optimizeImage(thumbUrl,'120x') + '"' +
    'data-src="' + bcsffilter.optimizeImage(thumbUrl,'master') + '"' +
    'data-srcset="' +
      bcsffilter.optimizeImage(thumbUrl,'128x') + ' 128w,' + ' ' +
      bcsffilter.optimizeImage(thumbUrl,'256x') + ' 256w,' + ' ' +
      bcsffilter.optimizeImage(thumbUrl,'440x') + ' 440w,' + ' ' +
      bcsffilter.optimizeImage(thumbUrl,'750x') + ' 750w,' + ' ' +
      bcsffilter.optimizeImage(thumbUrl,'1000x') + ' 1000w,' + ' ' +
      bcsffilter.optimizeImage(thumbUrl,'1500x') + ' 1500w' + '"' +
    'data-widths="[128, 256, 440, 750, 1000, 1500]"' +
    'data-sizes="auto"' + '"' +
  '/>';

  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    var flipImageUrl = images.length > 1 ? images[1]['src'] : thumbUrl;
    html += '<img class="bc-sf-filter-product-item-flip-image lazyload" ontouchmove ="return true"' +
      'src="' + bcsffilter.optimizeImage(flipImageUrl,'120x') + '"' +
      'data-src="' + bcsffilter.optimizeImage(flipImageUrl,'master') + '"' +
      'data-srcset="' +
        bcsffilter.optimizeImage(flipImageUrl,'128x') + ' 128w,' + ' ' +
        bcsffilter.optimizeImage(flipImageUrl,'256x') + ' 256w,' + ' ' +
        bcsffilter.optimizeImage(flipImageUrl,'440x') + ' 440w,' + ' ' +
        bcsffilter.optimizeImage(flipImageUrl,'750x') + ' 750w,' + ' ' +
        bcsffilter.optimizeImage(flipImageUrl,'1000x') + ' 1000w,' + ' ' +
        bcsffilter.optimizeImage(flipImageUrl,'1500x') + ' 1500w' + '"' +
      'data-widths="[128, 256, 440, 750, 1000, 1500]"' +
      'data-sizes="auto"' +
    '/>';
  }


  var productId = data.id;  
  var variantId = data.variants ? data.variants[0].id : 
                  data.variant_id ? data.variant_id : 
                  productId;
  var productUrl = data.url || data.handle || '';
  var fullProductUrl = productUrl ? window.location.origin + '/products/' + productUrl : window.location.origin;

  // Add Wishlist Button
  html += '<button ' +
    'aria-label="Add to Wishlist" ' +
    'data-with-epi="true" ' +
    'class="swym-button swym-add-to-wishlist-view-product product_' + productId + '" ' +
    'data-swaction="addToWishlist" ' +
    'data-product-id="' + productId + '" ' +
    'data-variant-id="' + variantId + '" ' +
    'data-product-url="' + fullProductUrl + '">'    
    '</button>';
  return html;
}

function buildMultipleImages(data){
  var html = '';
  // console.log('imageData', images.length);
  if(images.length > 0){
    for (var i = 0; i < images.length; i++) {
      html += '<a href="'+bcsffilter.buildProductItemUrl(data)+'" class="bc-sf-filter-product-item-image-link swiper-slide">';
      html += '<img class="bc-sf-filter-product-item-main-image lazyload" ontouchmove ="return true"' + 
        'src="'+ bcsffilter.optimizeImage(images[i]['src']) +'"' +
        'data-src="'+ bcsffilter.optimizeImage(images[i]['src'],'{width}x') +'"'+
        // 'srcset="' + bcsffilter.optimizeImage(images[i]['src'],'256x' ) + ' ' + '256w,' + ' ' + bcsffilter.optimizeImage(images[i]['src'],'512x' ) + ' ' + '512w,' + ' ' + bcsffilter.optimizeImage(images[i]['src'],'800x' ) + ' ' + '800w,' + ' ' + bcsffilter.optimizeImage(images[i]['src'],'1024x' ) + ' ' + '1024w' + '"' +
        'data-widths="[128, 256, 512, 767, 1024]" data-sizes="auto"' +
        '/>';
      html += '</a>';
    }
  }

  return html;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildPrice(data) {
  // console.log('data',data);
  var html = '';
  var vatRate = bcSfFilterConfig.custom.vat_rate;
  var $compareprice = Math.round(((data.compare_at_price_min*vatRate)/100).toFixed(2)*100);
  var $price = Math.round(((data.price_min*vatRate)/100).toFixed(2)*100);
  var salePercent = Math.round((data.compare_at_price_min-data.price_min)*100/data.compare_at_price_min);
  if (bcSfFilterConfig.custom.show_price) {
    if ($compareprice > $price ) {
      html += '<s>' + bcsffilter.formatMoney($compareprice) + '</s> ';
      if(salePercent != '' || salePercent != undefined){
        html += '<span>- '+ salePercent + '% = </span>'
      }
      html += '<span class="bc-sf-filter-product-item-sale-price test">' + bcsffilter.formatMoney($price) + '</span>';
    } else {
      if (priceVaries) {
        // html += (bcSfFilterConfig.label_basic.from) + ' ';
      }
      html += '<span class="bc-sf-filter-product-item-regular-price">' + bcsffilter.formatMoney($price) + '</span>';
    }
  }
  
  // if(!data.available){
  //  html += '<div class="pro-i-price font-italic">- SOLD OUT -</div>';
  // }
  return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Labels
  return soldOutLabel + saleLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}

// BUILD Permenant LABEL PRODUCT WITH TAGS
function buildPermenantTagLabels(data) {
    var permenanttagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("Permanent") !== -1) {
          permenanttagLabel += '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"><g clip-path="url(#clip0_12_125)"><path d="M4.00828 19.9941L6.51594 12.3543L0 7.65155C0.247516 7.65155 0.443312 7.65155 0.641324 7.65155C2.99457 7.65968 5.34708 7.66337 7.70032 7.68184C7.9567 7.68184 8.05866 7.60205 8.13403 7.3634C8.88396 4.99907 9.64646 2.63474 10.4053 0.270414C10.4223 0.215 10.4407 0.160325 10.4917 0.000732422C10.6831 0.616197 10.8397 1.13635 11.0089 1.65355C11.6214 3.55979 12.2443 5.4675 12.8486 7.37374C12.9284 7.62421 13.0474 7.68258 13.292 7.68111C15.7191 7.66411 18.1455 7.65968 20.5726 7.65155C20.6893 7.65155 20.8068 7.65155 20.9827 7.65155L14.4667 12.3536C15.2979 14.8879 16.1277 17.4177 16.9751 20C16.5318 19.669 16.1225 19.3572 15.7065 19.0535C14.0559 17.8477 12.4002 16.65 10.7562 15.4331C10.5456 15.278 10.4171 15.2935 10.2176 15.4413C8.21776 16.919 6.21326 18.3908 4.20407 19.8567C4.14792 19.9017 4.08807 19.9394 4.00828 19.9941Z" fill="black"></path></g><defs><clipPath id="clip0_12_125"><rect width="20.9827" height="20" fill="white"></rect></clipPath></defs></svg>',
          permenanttagLabel += '<span>Permanent Collections</span>';
        }
      }
    }
  
  return permenanttagLabel;
}

/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    paginationHtml = jQ.parseHTML(paginationHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};

// // Build Sorting
// BCSfFilter.prototype.buildFilterSorting = function() {
//   if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
//     jQ(this.selector.topSorting).html('');
//     var sortingArr = this.getSortingList();
//     console.log("sortingArr",sortingArr);
//     if (sortingArr) {
//       var paramSort = this.queryParams.sort || '';
//       // Build content
//       var sortingItemsHtml = '';
//       for (var k in sortingArr) {
//         activeClass = '';
//         if(paramSort == k) {
//           activeClass = 'active';
//         }
//         sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + sortingArr[k] + '</a></li>';
//       }
//       var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
//       html = jQ.parseHTML(html);
//       jQ('.bc-sf-filter-custom-sorting').html(html);
//       if(jQ('.bc-sf-filter-custom-sorting').hasClass("bc-sf-filter-sort-active")) {
//         jQ('.bc-sf-filter-custom-sorting').toggleClass('bc-sf-filter-sort-active');
//       }

//       var labelSort = '';
//       console.log("paramSort",paramSort);
//       if(paramSort.length > 0) {
//         var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
//         labelSort = bcSfFilterConfig.label[labelHandle];
//         if(labelSort == 'Featured'){
//           labelSort = "";
//         }
//       } else {
//         labelSort = bcSfFilterConfig.label.sorting;        
//       }
//       if (labelSort) jQ('.bc-sf-custom-sorting-label').text('(' + labelSort + ')');
//       if (labelSort) jQ('.bc-sf-selected-sorting-label').text('(' + labelSort + ')');
      
//     }
    
//     // jQ('#bc-sf-filter-options-wrapper').append(jQ('.bc-sf-filter-custom-sorting').outerHtml());
//   }
// };

// // Build Sorting event
// BCSfFilter.prototype.buildSortingEvent = function() {
//   var _this = this;
//   jQ('.bc-sf-filter-filter-dropdown a').click(function(e){
//     e.preventDefault();
//     onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
//     jQ('body').removeClass('sort-opened');
//     setTimeout(function(){
//       $('.bc-sf-sort-content-wrap').removeClass('active');
//     },200);
//   });

//   jQ(".bc-sf-filter-custom-sorting > label").click(function(){
//     //console.log('click1');
//     if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
//       jQ('.bc-sf-filter-filter-dropdown').toggle().parent().toggleClass('bc-sf-filter-sort-active');
//       // jQ('#bc-sf-filter-tree').hide();
//       jQ('body').addClass('sort-opened');
//     }
    
//   });

//   // jQ(this.getSelector('filterTreeMobileButton')).click(function(){
//   //   jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide();
//   // });
// };

  var openBtn = document.querySelector(".bc-sf-sort-content-wrap");
  if (openBtn) {
    openBtn.addEventListener("click", function () {
      document.body.classList.add("sorting-open");
    });
  }

  // Close sorting
  document.addEventListener('click',function(e){
    if(e.target.closest('.bc-sf-sort-pop-close')){
      document.body.classList.remove('sorting-open');
    }
  });

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (!sortingArr) return;

    var paramSort = this.queryParams.sort || '';

    /* ========= BUILD OPTIONS ========= */
    var sortingItemsHtml = '';
    for (var k in sortingArr) {
      var activeClass = (paramSort === k) ? 'active' : '';
      sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
    }

    var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    html = jQ.parseHTML(html);
    jQ('.bc-sf-filter-custom-sorting').html(html);
    jQ('.bc-sf-filter-custom-sorting').removeClass('bc-sf-filter-sort-active');

    /* ========= LABEL LOGIC ========= */
    var labelSort = '';

    if (this.isSortingApplied === true) {
      if (paramSort) {
        var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
        labelSort = bcSfFilterConfig.label[labelHandle] || '';
      }
    }

    if (labelSort) {
      jQ('.bc-sf-custom-sorting-label').text('(' + labelSort + ')');
      jQ('.bc-sf-selected-sorting-label').text('(' + labelSort + ')');
    } else {
      jQ('.bc-sf-custom-sorting-label').text('');
      jQ('.bc-sf-selected-sorting-label').text('');
    }
  }
};
// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;

  jQ('.bc-sf-filter-filter-dropdown a').off('click').on('click', function(e) {
    e.preventDefault();

    // 🔥 THIS IS THE KEY LINE
    _this.isSortingApplied = true;

    onInteractWithToolbar(
      e,
      'sort',
      _this.queryParams.sort,
      jQ(this).data('sort')
    );

    jQ('body').removeClass('sort-opened');
    setTimeout(function(){
      jQ('.bc-sf-sort-content-wrap').removeClass('active');
    },200);
  });

  jQ('.bc-sf-filter-custom-sorting > label').off('click').on('click', function(){
    if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
      jQ('.bc-sf-filter-filter-dropdown')
        .toggle()
        .parent()
        .toggleClass('bc-sf-filter-sort-active');
      jQ('body').addClass('sort-opened');
    }
  });
};


// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '';
  itemHtml += '<div class="bc-sf-filter-display-item" data-perrow="4"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H5.14286V5.14284H0V0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.85742H5.14286V12.0003H0V6.85742Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.85742 0H12.0003V5.14284H6.85742V0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.85742 6.85742H12.0003V12.0003H6.85742V6.85742Z" fill="black"/></svg></div>';
  // itemHtml += '<div class="bc-sf-filter-display-item" data-perrow="6"><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1905_219)"><rect x="0.5" y="0.5" width="6" height="6" stroke="black"/><rect x="0.5" y="8.5" width="6" height="6" stroke="black"/><rect x="0.5" y="16.5" width="6" height="6" stroke="black"/><rect x="8.5" y="0.5" width="6" height="6" stroke="black"/><rect x="8.5" y="8.5" width="6" height="6" stroke="black"/><rect x="8.5" y="16.5" width="6" height="6" stroke="black"/><rect x="16.5" y="0.5" width="6" height="6" stroke="black"/><rect x="16.5" y="8.5" width="6" height="6" stroke="black"/><rect x="16.5" y="16.5" width="6" height="6" stroke="black"/></g><defs><clipPath id="clip0_1905_219"><rect width="23" height="23" fill="white"/></clipPath></defs></svg></div>';
  // itemHtml += '<div class="bc-sf-filter-display-item" data-perrow="8"><svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1905_202)"><rect x="0.5" y="0.5" width="4" height="4" stroke="black"/><rect x="0.5" y="6.5" width="4" height="4" stroke="black"/><rect x="0.5" y="12.5" width="4" height="4" stroke="black"/><rect x="0.5" y="18.5" width="4" height="4" stroke="black"/><rect x="6.5" y="0.5" width="4" height="4" stroke="black"/><rect x="6.5" y="6.5" width="4" height="4" stroke="black"/><rect x="6.5" y="12.5" width="4" height="4" stroke="black"/><rect x="6.5" y="18.5" width="4" height="4" stroke="black"/><rect x="12.5" y="0.5" width="4" height="4" stroke="black"/><rect x="12.5" y="6.5" width="4" height="4" stroke="black"/><rect x="12.5" y="12.5" width="4" height="4" stroke="black"/><rect x="12.5" y="18.5" width="4" height="4" stroke="black"/><rect x="18.5" y="0.5" width="4" height="4" stroke="black"/><rect x="18.5" y="6.5" width="4" height="4" stroke="black"/><rect x="18.5" y="12.5" width="4" height="4" stroke="black"/><rect x="18.5" y="18.5" width="4" height="4" stroke="black"/></g><defs><clipPath id="clip0_1905_202"><rect width="23" height="23" fill="white"/></clipPath></defs></svg></div>';
  itemHtml += '<div class="bc-sf-filter-display-item" data-perrow="8"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H3.27273V3.27273H0V0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.36328H3.27273V7.63601H0V4.36328Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.72656H3.27273V11.9993H0V8.72656Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.36328 0H7.63601V3.27273H4.36328V0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.36328 8.72656H7.63601V11.9993H4.36328V8.72656Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.36328 4.36328H7.63601V7.63601H4.36328V4.36328Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.72754 4.36328H12.0003V7.63601H8.72754V4.36328Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.72754 0H12.0003V3.27273H8.72754V0Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.72754 8.72656H12.0003V11.9993H8.72754V8.72656Z" fill="black"/></svg></div>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  itemHtml = jQ.parseHTML(itemHtml);
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  var perRow = localStorage.getItem("bcProductsPerRow");
  if (!perRow) {
    perRow = window.matchMedia('(max-width: 767px)').matches ? 8 : 4;
  }
  topDisplayTypeSelector.find('.bc-sf-filter-display-item[data-perrow="' + perRow + '"]').addClass('active');
  listProductSelector.attr('data-perrow', perRow);
};

// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  // console.log(listProductSelector);
  jQ(this.getSelector('topDisplayType') + ' .bc-sf-filter-display-item').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    var perRow = jQ(this).data('perrow');
    localStorage.setItem("bcProductsPerRow", perRow);
    listProductSelector.attr('data-perrow', perRow);
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      html = jQ.parseHTML(html);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    html = jQ.parseHTML(html);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image').load(function() {
    var imageContainer = jQ(this).parent();
    imageContainer.css('width', '100%').css('height', jQ(this).height());
  }).each(function() {
    if (this.complete) jQ(this).load();
  });
}

function formRequest(value) {
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
    xhr.open("GET", value);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = () => resolve(xhr.responseText);
    xhr.onerror = () => reject(xhr.statusText);
    xhr.send();
  });
}


// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
      alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        }else{
          if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
              bcActionList.initFlag = false;
              bcActionList.alInit(bcSfFilterParams, bcAlParams);
          } else {
              bcActionList.alInit();
          }
        }
    }
    /* end-initialize-bc-al */
  // Call theme init function
  // if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
  //   $(theme.init);
  // }
  // End For List View

  for (var item of data) {
    var valueRequest = Shopify.routes.root + 'products/' + item.handle + '?view=bc-sf-prod-prices';
    var requestReg = formRequest(valueRequest);
    requestReg.then((res_success) => {
      var parse_res_success = JSON.parse(res_success);
      // console.log('parse_res_success',parse_res_success);
      var itemEl = jQ('[data-id="' + parse_res_success.id + '"]');
      if (itemEl.length > 0) {
        itemEl.find('.bc-sf-filter-product-item-price').html(buildPrice(parse_res_success));
      }
    }).catch((res_error) => {
      console.log(res_error)
    });
  }
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var _this = this;
  // var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
  // if (data.total_product == 1) {
  //   totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
  // }

  /* added new */
  // Target the anchor tags with onclick handlers
  // var filterOptions = document.querySelectorAll('.bc-sf-filter-option-item');
  
  // filterOptions.forEach(function(option) {
  //   option.addEventListener('click', function(e) {
  //     setTimeout(function() {
  //       if (typeof bcSfFilter !== 'undefined') {
  //         bcSfFilter.onFilter(); // Use bcSfFilter instead
  //       }
  //     }, 10);
  //   });
  // });
  
  // Add close buttons for selected filters
  var selectedFilters = document.querySelectorAll('.bc-sf-filter-option-item.selected');
  selectedFilters.forEach(function(item) {
    if (!item.querySelector('.filter-close-btn')) {
      var closeBtn = document.createElement('span');
      closeBtn.innerHTML = '×';
      closeBtn.className = 'filter-close-btn';
      closeBtn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        item.click();
      };
      item.appendChild(closeBtn);
    }
  });
/* end added new */

  var firstProduct = (_this.queryParams.page == 1) ? '1' : ((parseInt(_this.queryParams.limit) * (parseInt(_this.queryParams.page) - 1)) + 1).toString();
  var lastProduct = ((parseInt(_this.queryParams.page) * parseInt(_this.queryParams.limit)) < data.total_product) ? (parseInt(_this.queryParams.page) * parseInt(_this.queryParams.limit)).toString() : data.total_product;
  var totalProduct = firstProduct + ' - ' + lastProduct + ' of ' + data.total_product;
  totalProduct = jQ.parseHTML(totalProduct);
  jQ('#bc-sf-filter-total-product').html(totalProduct);
  matchHeightImage();
  jQ(window).resize(function() {
    matchHeightImage();
  });

  jQ('body').find('.bc-sf-filter-skeleton-button').remove();

  var ProSwiperImg = new Swiper('.bc-sf-filter-img-slider', {
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 5,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Prevent double tap on iOS
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isiOS){
    this.isMobile()&&jQ(".bc-sf-filter-product-item").find("a").on("touchstart",function(){isScrolling=!1}).on("touchmove",function(){isScrolling=!0}).on("touchend",function(){isScrolling||(window.location=jQ(this).attr("href"))});
  }

  // Fix image not loaded on mobile
  (this.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));
};

// Select horizontal filter option. Active when it's selected
function onSelectFilterOptionItem(event, element) {
  event.preventDefault();
  event.stopPropagation();

    if (jQ(element).data('count') > 0) {
        bcsffilter.selectFilter = true;
        var fVal = jQ(element).data('value').toString(),
            currentSelected = jQ(element).parents('.' + bcsffilter.class.filterOption).data('selected') || [];
        if (jQ(element).hasClass('selected')) {
            jQ(element).parent().children().removeClass('selected');
          	jQ(element).parent().children().attr('aria-expanded', 'false');
            // Un-selected: Remove this item from currentSelected array
            if(currentSelected.length) {
                currentSelected.splice(currentSelected.indexOf(fVal), 1);
            }
        } else {
            jQ(element).parent().children().addClass('selected');
          	jQ(element).parent().children().attr('aria-expanded', 'true');
            // Selected: add this item to currentSelected array
            currentSelected.push(fVal);
        }
        // Remove null items, Add attribute for current selected data
        currentSelected = currentSelected.filter(function(item){ return item.length > 0 });
        jQ(element).parents('.' + bcsffilter.class.filterOption).attr('data-selected', JSON.stringify(currentSelected));

    }
}

// Build Filter Option item in general
BCSfFilter.prototype.buildFilterOptionItem = function(html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) {
    var keepValuesStatic = fOData.hasOwnProperty('keepValuesStatic') ? fOData.keepValuesStatic : false;
    // Get Title which is only text and doesn't contain "product count"
    if (fOType == 'review_ratings' && this.getSettingValue('general.ratingSelectionStyle') == 'text') {
        var title = this.getReviewRatingsLabel(fOItemValue.from);
    } else {
        var title = this.customizeFilterOptionLabel(iLabel, fOData.prefix, fOType);
    }

    // Get product number
    if (keepValuesStatic === true) var productNumber = null;
    else var productNumber = fOItemValue.hasOwnProperty('doc_count') ? fOItemValue.doc_count : 0;

    // Build main attributes
    html = html.replace(/{{itemLabel}}/g, this.buildFilterOptionLabel(iLabel, productNumber, fOData));
    html = html.replace(/{{itemLink}}/g, this.buildFilterOptionLink(fOId, iValue, fOType, fODisplayType, fOSelectType, keepValuesStatic));
    html = html.replace(/{{itemValue}}/g, encodeURIParamValue(iValue));
    html = html.replace(/{{itemTitle}}/g, title);
    html = html.replace(/{{itemFunc}}/g, "onSelectFilterOptionItem(event, this)");
  	html = html.replace(/{{class.filterOptionItem}}/g, this.class.filterOptionItem);
  	html = html.replace(/{{class.filterOptionLabel}}/g, this.class.filterOptionLabel);
    // Check if item is selected or not
    html = this.checkFilterOptionSelected(fOId, iValue, fOType, fODisplayType) ? html.replace(/{{itemSelected}}/g, 'selected') : html.replace(/{{itemSelected}}/g, '');
    // Add additional attributes
    var htmlElement = jQ(html);
    htmlElement.children().attr({
        'data-id': fOId,
        'data-value': fOType == 'collection' ? encodeURIParamValue(iValue.split(':')[0]) : encodeURIParamValue(iValue),
        'data-parent-label': fOLabel,
        'data-title': title,
        'data-count': productNumber
    });
    
    // Add aria-label
    if (htmlElement.find('a').length > 0) {
        htmlElement.find('a').attr('aria-label', fOLabel + ' - ' + title);
    }
  	if (fOType == 'review_ratings' && this.getSettingValue('general.ratingSelectionStyle') == 'text') {
    	htmlElement.children().attr('aria-label', fOLabel + ' - ' + title);
    }
    // Add nofollow to all filter option links to increase SEO
    if (this.getSettingValue('general.enableSeo') && fOType != 'collection') {
        htmlElement.children().attr('rel', 'nofollow');
    }
    // Build Collection scope (for only Collection type)
    if (fOType == 'collection') htmlElement.children().attr('data-collection-scope', fOItemValue.key);
    return jQ(htmlElement)[0].outerHTML;
};

function showFilterResults() {
  applyFilterOption();
  $('.bc-sf-pop-close').trigger('click');
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

BCSfFilter.prototype.buildLoadPreviousButton = function(totalProduct, eventType) {
  var self = this;

  if (self.isLoadPreviousPagePaginationType()) {
    // Get previous button selector
    var btnLoadPreviousPageWrapperSelector = jQ(this.getSelector('btnLoadPreviousPageWrapperSelector'));
    var btnLoadPreviousPageSelector = jQ(self.getSelector('btnLoadPreviousPageSelector'));

    // Build load previous template: if the previous button does not exist, build it
    if (btnLoadPreviousPageSelector.length == 0) {
      var btnLoadPreviousPageTemplate = self.getTemplate('btnLoadPreviousPageTemplate');
      if (this?.queryParams?.limit) {
        btnLoadPreviousPageTemplate = btnLoadPreviousPageTemplate.replace(/{{count}}/g, this.queryParams.limit);
      } else {
        btnLoadPreviousPageTemplate = btnLoadPreviousPageTemplate.replace(/{{count}}/g, '');
      }
      btnLoadPreviousPageWrapperSelector.html(btnLoadPreviousPageTemplate);
    }

    // Get filter params
    var params = self.queryParams;

    // Get total page
    var totalPage = Math.ceil(totalProduct / params.limit);

    // Get current page
    var currentPage = params.page;

    // If total page > 1; current page > 1; event_type = init and event_type != 'page', show load previous button and save previous page data to the sessionStorage
    var showPreviousFlag = (totalPage > 1 && currentPage > 1) ? true : false;

    if (eventType == 'init' || eventType != 'page') {
      sessionStorage.setItem(self.getSettingValue('general.sessionStorageCurrentPreviousPage'), currentPage);
      sessionStorage.setItem(self.getSettingValue('general.sessionStorageCurrentPage'), currentPage);
      sessionStorage.setItem(self.getSettingValue('general.sessionStorageCurrentNextPage'), currentPage);
      sessionStorage.setItem(self.getSettingValue('general.sessionStoragePreviousPageEvent'), 1);

      if (showPreviousFlag) {
        btnLoadPreviousPageWrapperSelector.show();
      } else {
        btnLoadPreviousPageWrapperSelector.hide();
      }
    }
  }
};

const isiOS = () => {
	return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};
const isSafari = () => {
	return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
};

window.addEventListener("pageshow", function(evt){
  if(evt.persisted && isiOS() || evt.persisted && isSafari()){
    location.reload();
  }
}, false);